import { COLOR_BLACK, COLOR_GRADIENT_BG, COLOR_NEUTRAL_LIGHT } from './colors.constants';
import {
  colorsButton,
  colorsCard,
  colorsIconButton,
  colorsMenu,
  colorsQuestStatus,
  colorsRadioAndCheckbox,
  colorsTabs,
  colorsTextField,
  colorsTimer,
  colorsTooltip,
  colorsTypography,
} from './components';

export const colorThemes = {
  background: COLOR_GRADIENT_BG,
  mainColor: COLOR_BLACK,
  borderMain: COLOR_NEUTRAL_LIGHT,
  ...colorsButton,
  ...colorsIconButton,
  ...colorsRadioAndCheckbox,
  ...colorsTextField,
  ...colorsCard,
  ...colorsTypography,
  ...colorsQuestStatus,
  ...colorsMenu,
  ...colorsTabs,
  ...colorsTimer,
  ...colorsTooltip,
};
